import TimestampRangePicker from '@/components/timestamp-RangePicker';
import { message, Modal, Form, Row, Col, Input, Select, Button } from '@drip/drip-design';
import React, { useState, useEffect } from 'react';
import { listWhiteEnum, addWhiteTemplate, updateWhiteTemplate, templateDetail } from '../../apis';
import WangeditorForAcore from '@/components/wangeditor-for-acore';
import moment from 'moment';
import { formateTimeStampToSecondPrecision } from '@/common/utils';

const ListConfigEdit: React.FC<any> = (props) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const { isEdit, businessType, id, businessId, freshList = () => {}, lineType } = props;
  const [list, setList] = useState([]);
  const [initFormVal, setInitFormVal] = useState<any>({});

  function changeStatus(trueCb: any, falseCb: any) {
    return isEdit ? trueCb : falseCb;
  }

  useEffect(() => {
    if (!visible) return;
    listWhiteEnum({ businessType, businessId, lineType })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '白名单类型请求失败';
        setList(data.list || []);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [businessType, visible, businessId, lineType]);

  useEffect(() => {
    if (!id || !form || !visible) return;
    templateDetail({ id })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '白名单类型请求失败';
        const { applyBeginTime, applyEndTime, effectiveBeginTime, effectiveEndTime } = data;
        const applyTime = { applyBeginTime, applyEndTime };
        const effectiveTime = { effectiveBeginTime, effectiveEndTime };
        setInitFormVal({ ...data, applyTime, effectiveTime });
        form.setFieldsValue({ ...data, applyTime, effectiveTime });
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [id, form, visible]);

  let btn = React.cloneElement(props.children, {
    onClick: () => setVisible(true),
  });

  const getOptions = () => {
    return list.map((item: any) => {
      return {
        label: item.whiteName,
        value: item.whiteType,
      };
    });
  };

  const closeModal = () => {
    form.resetFields();
    setVisible(false);
  };

  const submitForm = (val: any) => {
    const value = { ...val, ...val.applyTime, ...val.effectiveTime };
    delete value.applyTime;
    delete value.effectiveTime;
    const save = changeStatus(updateWhiteTemplate, addWhiteTemplate);
    save({ id, businessId, businessType, ...value })
      .then((res: any) => {
        const { ret, msg } = res;
        if (ret !== '0') throw msg || '请完善无误后，再试试';
        message.success(changeStatus('信息保存成功', '新建成功'));
        setVisible(false);
        freshList();
      })
      .catch((ex: any) => {
        message.error(ex);
      });
  };

  const footer = (
    <div>
      <Button onClick={closeModal}>取消</Button>
      <Button type="primary" onClick={() => form.submit()}>
        {changeStatus('保存信息', '立即新建')}
      </Button>
    </div>
  );

  return (
    <>
      {btn}
      <Modal
        width={900}
        title={changeStatus('编辑白名单', '新建白名单')}
        visible={visible}
        footer={footer}
        onCancel={closeModal}
      >
        <Form layout="vertical" form={form} onFinish={submitForm}>
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Form.Item
                name="whiteName"
                label="白名单名称"
                required
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="whiteType"
                label={
                  <span>
                    白名单类型
                    {[3].includes(businessType) && (
                      <span style={{ color: 'red', marginLeft: 8, fontSize: '11px' }}>
                        选品白名单开通后，需在收品池选品设置对应的{'<'}系统白名单{'>'}标签
                      </span>
                    )}
                  </span>
                }
                required
                rules={[{ required: true, message: '请选择类型' }]}
              >
                <Select options={getOptions()} placeholder="请输入" disabled={isEdit} />
              </Form.Item>
            </Col>
            {[3].includes(businessType) ? (
              <Col span={12}>
                <Form.Item
                  name="effectiveTime"
                  label="白名单生效时间"
                  rules={[
                    { required: true, message: '请选择时间' },
                    {
                      validator: (_, val) => {
                        return new Promise((resolve, reject) => {
                          if (
                            val?.effectiveEndTime !== initFormVal?.effectiveEndTime &&
                            val?.effectiveEndTime <= moment().valueOf()
                          ) {
                            return reject(new Error('结束时间不能早于当前时间！'));
                          }
                          return resolve(true);
                        });
                      },
                    },
                  ]}
                  initialValue={{
                    effectiveBeginTime: moment().startOf('day').valueOf(),
                    effectiveEndTime: formateTimeStampToSecondPrecision(moment().add(7, 'days').endOf('day').valueOf()),
                  }}
                >
                  <TimestampRangePicker
                    showTime
                    fieldNames={{ start: 'effectiveBeginTime', end: 'effectiveEndTime' }}
                  />
                </Form.Item>
              </Col>
            ) : (
              <Col span={12}>
                <Form.Item name="applyTime" label="白名单申请时间" rules={[{ required: true, message: '请选择时间' }]}>
                  <TimestampRangePicker showTime fieldNames={{ start: 'applyBeginTime', end: 'applyEndTime' }} />
                </Form.Item>
              </Col>
            )}
            <Col span={24}>
              <Form.Item
                name="applyContent"
                label="白名单申请须知"
                rules={[{ required: true, message: '请填写申请须知' }]}
              >
                {/*@ts-ignore */}
                <WangeditorForAcore height={150} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default ListConfigEdit;
